// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testTest * {
    border: 0px solid transparent !important;
}

.testTest {
    width: 200px;
}

.testTest .bg__value-container {
    /* direction: rtl; */
}`, "",{"version":3,"sources":["webpack://./src/_competition/pages/AllCompetitionsPage/styles.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":[".testTest * {\n    border: 0px solid transparent !important;\n}\n\n.testTest {\n    width: 200px;\n}\n\n.testTest .bg__value-container {\n    /* direction: rtl; */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testTest * {
    border: 0px solid transparent !important;
}

.testTest {
    width: 200px;
}

.testTest .bg__value-container {
    /* direction: rtl; */
}`, "",{"version":3,"sources":["webpack://./src/_competition/pages/AllCompetitionsPage/styles.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":[".testTest * {\n    border: 0px solid transparent !important;\n}\n\n.testTest {\n    width: 200px;\n}\n\n.testTest .bg__value-container {\n    /* direction: rtl; */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
